import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Answer from "../../answers/Answers";
import { connect } from "react-redux";
import { Skeleton } from "@material-ui/lab";

import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
const Cookie = new Cookies();
function EditQuestionPreview({ questionData, rootData }) {
  // console.log(questionData);
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  const backToLoginPage = () => {
    history.push("/login");
  };
  return (
    <React.Fragment>
      {token ? (
        <Container className="py-10">
          <Row>
            <Col md={12} className="pt-4 questionMain">
              <h2 className="mb-0 text-gray-700 text-3xl">
                {questionData.editQuestion ? (
                  questionData.editQuestion
                ) : (
                  <Skeleton variant="text" height={70} animation="wave"/>
                )}
              </h2>
              <h5 className="mb-3 text-lg text-gray-500">{questionData.editDescription}</h5>
              <div className="questiontimeAsked flex mt-2">
                <div className="asked mr-3">
                  <span className="text-sm text-gray-500 mr-2">Asked</span>
                  <span className="text-sm">today</span>
                </div>
                <div className="active mr-3">
                  <span className="text-sm text-gray-500 mr-2">Active</span>
                  <span className="text-sm">today</span>
                </div>
              </div>
              <div className="flex items-center pt-2 pb-2">
                <div className="profile_image h-16 mr-2 w-16 rounded-full border bg-white">
                  {rootData.userProfilePic ? (
                    <Link to="/user">
                      <img
                        src={rootData.userProfilePic}
                        alt="prof"
                        className="blog_profile rounded-full w-full h-full object-cover"
                      />
                    </Link>
                  ) : (
                    <Skeleton variant="circle" className="w-16 blog_profile" height={64}/>
                  )}
                </div>
                <div className="profile_details leading-4">
                  <div className="profile_top">
                    <Link to="/user">
                      <span className="mr-3 text-black">
                        {rootData.fname} {rootData.lname}
                      </span>
                    </Link>
                  </div>
                  <div className="questionProfileStats mt-2">
                    {/* <span className="pr-3 text-sm relative">25</span>
                    <span className="pr-3 text-sm">6</span> */}
                  </div>
                </div>
              </div>
            </Col>
            {/* ANSWERS */}
            {/* <Col md={8} className="mt-4">
              <div className="answersWrapper">
                <Answer rootData={rootData} />
              </div>
            </Col> */}
          </Row>
        </Container>
      ) : (
        backToLoginPage()
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, null)(EditQuestionPreview);
